module.exports = __webpack_public_path__ + "assets/top_hide.png";